import * as React from 'react';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import { ANALYTICS, PADDING } from '@latitude/core/utils/constants';
import { Vertical } from '@latitude/spacing';
import { Outer, Inner } from './Footer.styles';
import Social from './components/Social/Social';
import AppLinks from './components/AppLinks/AppLinks';
import SiteLinks from './components/SiteLinks/SiteLinks';
import FooterLinks from './components/FooterLinks/FooterLinks';
import FinePrint from './components/FinePrint/FinePrint';
const Footer = props => {
  return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
    location: ANALYTICS.LOCATION.FOOTER
  }, /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Social, {
    data: props.socialLinks,
    isNz: props.isNz ? true : false
  }), /*#__PURE__*/React.createElement(SiteLinks, {
    data: props.siteLinks,
    cardData: props.cardData
  }), /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(Vertical, {
    spacing: PADDING.P32
  }, props.appLinks && /*#__PURE__*/React.createElement(AppLinks, {
    data: props.appLinks
  }), props.footerLinks && /*#__PURE__*/React.createElement(FooterLinks, {
    data: props.footerLinks
  }), props.finePrint && /*#__PURE__*/React.createElement(FinePrint, {
    data: props.finePrint
  })))));
};
export default Footer;